<template>
  <div class="">
    <div>
      <b-tabs content-class="pt-1" lazy v-model="tabIndex">
        <b-tab
          v-for="(tab, index) in tabs"
          :key="index"
          @click="onTabClick(tab, index)"
          :title="tab.text"
          :active="active(index)"
          title-item-class="lisaweb"
        >
          <keep-alive>
            <component :is="selected"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import DirectDebits from "@/components/sepa/direct-debits/index.vue";
import PaymentProcedures from "@/components/sepa/payment-procedures/index.vue";
import ShortcutsAndBreadcrumbsMixin from "@/mixins/ShortcutsAndBreadcrumbsMixin";

export default {
  mixins: [ShortcutsAndBreadcrumbsMixin],
  data() {
    return {
      path: "module.PROF",
      tabs: [
        { name: "DirectDebits", text: "Flussi" },
        { name: "PaymentProcedures", text: "Quietanze" },
      ],
      tabsGroup: "Management",
      // breadcrumbs settings: bcs & maxLevel
      bcs: [
        {
          text: "SEPA",
          path: "",
          level: 0,
          disabled: true,
        },
        {
          text: "SEPA",
          path: "",
          level: 1,
        },
        {
          text: "Gestione SEPA",
          path: "",
          level: 2,
        },
        {
          text: "Quietanze",
          path: "module.SEPA",
          tab: `#${this.selected}`,
          level: 3,
        },
      ],
      maxLevel: 3, // use to identify the tabs level
      selected: "DirectDebits",
      tabIndex: 0,
      // isLoading: false,
    };
  },
  components: {
    PaymentProcedures,
    DirectDebits,
  },
};
</script>
